export default __webpack_public_path__ + "static/media/saint-laurent.4283a209.jpg";